var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center my-5"},[_c('h1',{staticClass:"text-primary text-uppercase"},[_vm._v(_vm._s(_vm.$t(_vm.$getConst.pages.allowed.not_allowed)))]),_c('h3',[_vm._v(_vm._s(_vm.$t(_vm.$getConst.pages.allowed.not_allowed_access)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }